var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    _vm._b({}, "v-flex", _vm.$attrs, false),
    [
      _c(
        "v-card",
        [
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c(
                "v-flex",
                [
                  _c("Toolbar", {
                    attrs: {
                      title: _vm.title,
                      shouldShowSearch: _vm.shouldShowSearch,
                      actions: _vm.toolbarActions,
                      isPrimary: _vm.isPrimary,
                      icon: _vm.icon,
                      breadCrumbs: _vm.breadCrumbs,
                      isLoading: _vm.isPrimary && _vm.isLoading,
                    },
                    on: {
                      onClicked: (val) => _vm.$emit("onClicked", val),
                      onClickBreadcrumb: (val) =>
                        _vm.$emit("onClickBreadcrumb", val),
                      onShouldSearch: (val) => _vm.$emit("onShouldSearch", val),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "toolbarExtension",
                          fn: function () {
                            return [_vm._t("toolbarExtension")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", [_vm._t("default")], 2),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }